import React, { useEffect, useRef } from 'react';

import L from 'leaflet';

const MyMap = (props) => {
    const key = process.env.REACT_APP_GEOAPIFY_API_KEY;
    const keySeznam = process.env.REACT_APP_SEZNAM_API_KEY;
    const mapContainerRef = useRef(null);
    const mapRef = useRef(null);

    useEffect(() => {
        if (mapRef.current) return;

        const initialState = {
            lat: 48.148598,
            lon: 17.107748,
            zoom: 11
        };
        const map = L.map(mapContainerRef.current).setView([initialState.lat, initialState.lon], initialState.zoom);
        mapRef.current = map;

        L.tileLayer(
            "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            name: 'OpenStreetMap',
            attribution: '&copy; <a href=&quot;https://www.openstreetmap.org/copyright&quot;>OpenStreetMap</a> contributors',
            maxZoom: 16,
        }).addTo(map);
        L.tileLayer(
            "https://api.mapy.cz/v1/maptiles/aerial/256/{z}/{x}/{y}?apikey={apiKey}", {
            name: 'Seznam Letecká',
            attribution: '<a href=&quot;https://api.mapy.cz/copyright&quot; target=&quot;_blank&quot;>&copy; Seznam.cz a.s. a další</a>',
            apiKey: keySeznam,
            minZoom: 16,
            maxZoom: 17,
        }).addTo(map);
        L.tileLayer(
            "https://api.mapy.cz/v1/maptiles/names-overlay/256/{z}/{x}/{y}?apikey={apiKey}", {
            name: 'Seznam Popisky',
            attribution: '<a href=&quot;https://api.mapy.cz/copyright&quot; target=&quot;_blank&quot;>&copy; Seznam.cz a.s. a další</a>',
            apiKey: keySeznam,
            minZoom: 16,
            maxZoom: 17,
        }).addTo(map);

        map.on('click', onMapClick);
        const resizeTimeout = setTimeout(function () { map.invalidateSize() }, 1000);
        props.callbackHandler(map);

        return () => {
            clearTimeout(resizeTimeout);
            map.remove();
            mapRef.current = null;
        };
    }, []);

    function onMapClick(e) {
        const map = mapRef.current;
        if (!map) return;
        map.invalidateSize(true);
        //fetch(`https://api.geoapify.com/v1/geocode/reverse?lang=cs&lat=${e.latlng.lat}&lon=${e.latlng.lng}&apiKey=${key}`)
        //    .then(response => response.json())
        //    .then(result => {
        //        if (result.features.length) {
        //            const address = result.features[0].properties.formatted;
        //            props.clickHandler(result.features[0]);
        //            L.popup().setLatLng(e.latlng).setContent(address).openOn(map);
        //        } else {
        //            L.popup().setLatLng(e.latlng).setContent("Adresa nenalezená").openOn(map);
        //        }
        //    });
        fetch(`https://api.mapy.cz/v1/rgeocode/?lat=${e.latlng.lat}&lon=${e.latlng.lng}&lang=sk&apiKey=${keySeznam}`)
            .then(response => response.json())
            .then(result => {
                if (result.items.length) {
                    const address = result.items[0].name + ', ' + result.items[0].location;
                    if (result.items[0].zip == undefined) {
                        L.popup().setLatLng(e.latlng).setContent("Prosím, vyberte presnejšiu adresu <br>" + address).openOn(map);
                    } else {
                        props.clickHandler(result.items[0]);
                        L.popup().setLatLng(e.latlng).setContent(address).openOn(map);
                    }
                } else {
                    L.popup().setLatLng(e.latlng).setContent("Adresa nebola nájdená").openOn(map);
                }
            });
    }

    return (
        <div className="map-container" ref={mapContainerRef}></div>
    )
}

export default MyMap;